import { CalloutsWrapper } from "@clipboard-health/ui-components";
import { Box, Skeleton } from "@mui/material";

import { ActiveNegotiationsCallout } from "./ActiveNegotiationsCallout";
import { BookingRequestsCallout } from "./BookingRequestsCallout";
import { PendingBreakPaymentRequestsCallout } from "./PendingBreakPaymentRequestsCallout";
import { PendingSentHomeRequestsCallout } from "./PendingSentHomeRequestsCallout";
import { ShiftInviteCallout } from "./ShiftInviteCallout";
import { UnverifiedShiftsCallout } from "./UnverifiedShiftsCallout";
import { WorkplaceProposalCallout } from "./WorkplaceProposalCallout";

interface Props {
  shiftInviteCount: number;
  unverifiedShiftsCount: number;
  activeNegotiationsCount: number;
  facilityProposalsCount: number;
  extraWorkedRequestsCount: number;
  sentHomeRequestsCount: number;
  bookingRequestsCount: number;
  isLoadingShiftInvites: boolean;
  isLoadingUnverifiedShifts: boolean;
  isLoadingNegotiations: boolean;
  isLoadingSentHome: boolean;
  isLoadingExtraWorked: boolean;
  isLoadingBookingRequests: boolean;
  isMissedPunchRequestEnabled: boolean;
}

// eslint-disable-next-line complexity
export function WorkerShiftsCalloutsContainer(props: Props) {
  const {
    shiftInviteCount,
    unverifiedShiftsCount,
    activeNegotiationsCount,
    facilityProposalsCount,
    extraWorkedRequestsCount,
    sentHomeRequestsCount,
    bookingRequestsCount,
    isLoadingShiftInvites,
    isLoadingUnverifiedShifts,
    isLoadingNegotiations,
    isLoadingSentHome,
    isLoadingExtraWorked,
    isLoadingBookingRequests,
    isMissedPunchRequestEnabled,
  } = props;

  const isLoading =
    isLoadingShiftInvites ||
    isLoadingUnverifiedShifts ||
    isLoadingNegotiations ||
    isLoadingSentHome ||
    isLoadingBookingRequests ||
    isLoadingExtraWorked;

  const shouldShowUnverifiedShifts = unverifiedShiftsCount > 0 && !isMissedPunchRequestEnabled;

  const hasCallouts =
    shiftInviteCount > 0 ||
    shouldShowUnverifiedShifts ||
    activeNegotiationsCount > 0 ||
    facilityProposalsCount > 0 ||
    extraWorkedRequestsCount > 0 ||
    bookingRequestsCount > 0 ||
    sentHomeRequestsCount > 0;

  return (
    <Box sx={{ marginX: -4 }}>
      {isLoading && (
        <CalloutsWrapper sx={{ paddingX: 4 }}>
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton
              // eslint-disable-next-line react/no-array-index-key
              key={`worker-shift-callout-skeleton-${index}`}
              variant="rounded"
              sx={{
                height: 36,
                width: "60%",
              }}
              aria-label="Loading shift notifications"
            />
          ))}
        </CalloutsWrapper>
      )}
      {!isLoading && hasCallouts && (
        <CalloutsWrapper sx={{ paddingX: 5 }}>
          {shiftInviteCount > 0 && <ShiftInviteCallout shiftInviteCount={shiftInviteCount} />}
          {bookingRequestsCount > 0 && <BookingRequestsCallout />}
          {shouldShowUnverifiedShifts && (
            <UnverifiedShiftsCallout unverifiedShiftsCount={unverifiedShiftsCount} />
          )}
          {activeNegotiationsCount > 0 && (
            <ActiveNegotiationsCallout activeNegotiationsCount={activeNegotiationsCount} />
          )}
          {facilityProposalsCount > 0 && (
            <WorkplaceProposalCallout facilityProposalsCount={facilityProposalsCount} />
          )}
          {extraWorkedRequestsCount > 0 && (
            <PendingBreakPaymentRequestsCallout
              extraWorkedRequestsCount={extraWorkedRequestsCount}
            />
          )}
          {sentHomeRequestsCount > 0 && (
            <PendingSentHomeRequestsCallout sentHomeRequestsCount={sentHomeRequestsCount} />
          )}
        </CalloutsWrapper>
      )}
    </Box>
  );
}
